export { default } from './SectionTopArticles';